<template>
  <v-container text-xs-center>
    <v-layout row wrap>
      <v-flex xs12>
        <v-btn block @click="goToMainView">
          <v-icon>arrow_back</v-icon>
          <span>Wróć do widoku głównego</span>
        </v-btn>

        <v-card>
          <v-card-title primary-title>
            <div>
              <div class="headline">Historia</div>
              <span class="grey--text">Widok napojów z ostatniego miesiąca.</span>
            </div>
          </v-card-title>
          <v-card-text>

            <v-list two-line>
              <template v-for="(propValue, propName, index) in historyParsed">
                <!--{{propValue}}-->
                <v-subheader :key="index">{{propName}}</v-subheader>
                <v-list-tile avatar v-for="(historyItem, historyIndex) in propValue" :key="historyIndex+'history'+historyItem.id">

                  <v-list-tile-avatar>
                    <v-icon>local_drink</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>{{getDrinkProperties(historyItem.drinkId).name}}</v-list-tile-title>
                    <v-list-tile-sub-title>{{historyItem.size}}ml</v-list-tile-sub-title>
                  </v-list-tile-content>

                </v-list-tile>

              </template>
            </v-list>
          </v-card-text>
          <v-card-actions>
          </v-card-actions>
        </v-card>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import moment from 'moment'

  moment.locale('pl');
  export default {
    name: 'fullHistory',
    // props: ['myWeight'],
    data() {
      return {
        drunkHistory: [
          {
            id: 1,
            drinkId: 1,
            dateTime: new Date(),
            size: 200,
            active: true,
          }
        ],
        // testDrinks: {
        //   "dzisiaj": [
        //     {
        //       id: 1,
        //       name: "Woda",
        //       size: 200,
        //       active: true,
        //     }
        //   ],
        //   "wczoraj": [
        //     {
        //       id: 1,
        //       name: "Woda",
        //       size: 200,
        //       active: true,
        //     }
        //   ],
        // },
        availableDrinks: [
          {
            id: 1,
            name: "Woda",
            size: 200,
            active: true,
          },
        ]
      }
    },
    mounted() {
      if (localStorage.getItem('drunkHistory')) this.drunkHistory = JSON.parse(localStorage.getItem('drunkHistory'));
      if (localStorage.getItem('availableDrinks')) this.availableDrinks = JSON.parse(localStorage.getItem('availableDrinks'));
      console.log(this.historyParsed)
    },
    computed: {
      historyParsed() {
        let history = {};
        this.drunkHistory.forEach((obj) => {
          if (moment(obj.dateTime).isAfter(moment().subtract(1, 'months'), "month")) {
            let date = moment(obj.dateTime).format('LL');
            if (date in history) {
              history[date].push(obj);
            } else {
              history[date] = [];
              history[date].push(obj)

            }
            // console.log()
            console.log(obj)
          }
        });

        console.log(history)
        // if (Object.keys(history).length > 1) {
        //   history = history.reverse()
        // }

        var reverseObj = function (object) {
          var NewObj = {}, keysArr = Object.keys(object);
          for (var i = keysArr.length - 1; i >= 0; i--) {
            NewObj[keysArr[i]] = object[keysArr[i]];
          }
          return NewObj;
        }

        return history

      }
    },
    methods: {
      getDrinkProperties(id) {
        return this.availableDrinks.find((obj) => {
          return obj.id === id
        })
      },
      goToMainView() {
        this.$router.push({name: 'mainView'});

      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/fullHistory.vue